import { render, staticRenderFns } from "./KitOption.vue?vue&type=template&id=631a9174"
import script from "./KitOption.vue?vue&type=script&lang=js"
export * from "./KitOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports